import axios from 'axios'

export default {
  namespaced: true,

  state: {
  },

  mutations: {
  },

  actions: {
    async loadModello (_, { tipoModello, annoImposta }) {
      try {
        let rs = await axios.get(`/api/modelli/${annoImposta}/${tipoModello}`)
        return rs.data
      } catch (err) {
        throw err
      }
    }
  }

}
